import { render, staticRenderFns } from "./VideoMarkerManager.vue?vue&type=template&id=7b3137fc&scoped=true"
import script from "./VideoMarkerManager.vue?vue&type=script&lang=js"
export * from "./VideoMarkerManager.vue?vue&type=script&lang=js"
import style0 from "./VideoMarkerManager.vue?vue&type=style&index=0&id=7b3137fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3137fc",
  null
  
)

export default component.exports